<!-- Carry-over designation (PBI 5770 AC#3), shared by the event and details dialogs -->
@if (hasCarryOver()) {
  <div class="carryover-row">
    <div class="carryover-heading">
      <span class="carryover-chip">{{ label() }}</span>
      <span class="carryover-count">
        {{ dates().length }} of {{ daysOff() }}
        {{ daysOff() === 1 ? "day" : "days" }} from carry-over
      </span>
    </div>
    <div class="carryover-dates">{{ datesText() }}</div>
  </div>
}
